export default __webpack_public_path__ + "static/media/copy.fd10ca56.svg";